
<fury-page-layout mode="card">
    <fury-page-layout-header>
        <div class="top_heading">
            <fury-breadcrumbs [@fadeInRight]  current="Lead Partners Performance"></fury-breadcrumbs>

            <div class="daterange">
                  <mat-form-field class="example-form-field" appearance="outline">
                      <mat-label>Date Range</mat-label>
                      <mat-date-range-input
                      [formGroup]="campaignOne"
                      [rangePicker]="campaignOnePicker"
                      [max]="today">
                      <input matStartDate placeholder="Start date" formControlName="start" #dateRangeStart>
                      <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                      </mat-date-range-input>
                      <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                      <mat-datepicker-toggle matIconSuffix [for]="campaignOnePicker"></mat-datepicker-toggle>
                      <mat-date-range-picker #campaignOnePicker>
                          <mat-date-range-picker-actions>
                              <button class="apply" mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
                              <button class="can" mat-button matDateRangePickerCancel>Cancel</button>
                          </mat-date-range-picker-actions>
                      </mat-date-range-picker>
                  </mat-form-field>
              </div>
        </div>
      
    </fury-page-layout-header>
  
    <fury-page-layout-content [@fadeInUp]>
      <fury-list name={{filterValue}} [columns]="columns" (filterChange)="onFilterChange($event)">
        <div class="table_container">
            <table [dataSource]="dataSource" mat-table>
                <!-- actions Column -->
                <ng-container matColumnDef="actions">
                    <th *matHeaderCellDef class="actions-cell" mat-header-cell>Actions</th>
                    <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                        <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                            (click)="$event.stopPropagation()">
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                            <button mat-menu-item routerLink="/lead-partners/lead-partner-performance-details/{{row?.leadPartnerId}}">
                                <span>View</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>
              
                <ng-container matColumnDef="leadPartnerTitle">
                    <th mat-header-cell *matHeaderCellDef>Lead Partner Title</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.leadPartnerTitle}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="leadCount">
                    <th mat-header-cell *matHeaderCellDef>Lead Count</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.leadCount}}
                    </td>
                </ng-container>
                 
                <tr *matHeaderRowDef="visibleColumns; sticky: true" mat-header-row></tr>
                <tr *matRowDef="let row; columns: visibleColumns"
                    class="clickable route-animations-elements" mat-row>
                </tr>
            </table>
        </div>
        
        <div *ngIf="itemList?.length === 0" style="padding: 10px 0; text-align:center;">
            No data found.
        </div>
       
       
        <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
        showFirstLastButtons
        [selectConfig] = "selectConfig"
        [ngClass]="{'mat-pegig': pageSize === 9999}"
        aria-label="Select page of periodic elements">
    </mat-paginator>
      </fury-list>
  
    </fury-page-layout-content>
  </fury-page-layout>
  




